import React from "react";
import { Box, Typography } from "@mui/material";
import GoogleIcon from "../../../../icon/GoogleIcon";
import {
  UI_COLOR_WHITE,
  UI_COLOR_SURFACE_900,
  UI_COLOR_TEXT_MUTED_LIGHT,
  UI_COLOR_BORDER_SURVEY_DROPZONE
} from "../../../../constants/uiColors";

export default function DropzonePreview() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        px: "16px",
        py: "14px",
        borderRadius: "8px",
        backgroundColor: UI_COLOR_WHITE,
        border: `1px dashed ${UI_COLOR_BORDER_SURVEY_DROPZONE}`
      }}
    >
      <GoogleIcon name="image" size={20} color={UI_COLOR_TEXT_MUTED_LIGHT} />

      <Box>
        <Typography
          sx={{
            fontWeight: 700,
            color: UI_COLOR_SURFACE_900,
            fontSize: 14,
            lineHeight: "16px"
          }}
        >
          Puedes adjuntar varias imágenes
        </Typography>

        <Typography
          sx={{
            fontSize: 12,
            lineHeight: "13px",
            color: UI_COLOR_SURFACE_900
          }}
        >
          JPG o PNG, tamaño del archivo no mayor a 5MB
        </Typography>
      </Box>
    </Box>
  );
}
